// Cart Validation for Gift Hampers
// Prevents combining Gift Hampers and normal products in the cart.

(function() {
  const originalFetch = window.fetch;

  // Inject modal CSS styles dynamically
  const style = document.createElement('style');
  style.id = 'cart-conflict-modal-styles';
  style.textContent = `
    #cart-conflict-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.4);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999999;
      opacity: 0;
      transition: opacity 0.25s ease;
    }

    #cart-conflict-modal .modal-card {
      background-color: var(--color-background, #ffffff);
      color: var(--color-foreground, #2b2b2b);
      border-radius: 16px;
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
      border: 1px solid var(--color-border, rgba(0, 0, 0, 0.1));
      width: 90%;
      max-width: 440px;
      padding: 32px 28px;
      text-align: center;
      transform: scale(0.92);
      transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
      font-family: inherit;
      box-sizing: border-box;
    }

    #cart-conflict-modal .modal-title {
      font-size: 22px;
      font-weight: 700;
      margin: 0 0 14px 0;
      color: var(--color-foreground, #111111);
      line-height: 1.3;
    }

    #cart-conflict-modal .modal-body {
      font-size: 14px;
      line-height: 1.6;
      margin: 0 0 26px 0;
      opacity: 0.85;
    }

    #cart-conflict-modal .btn-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
    }

    #cart-conflict-modal .modal-btn {
      width: 100%;
      padding: 12px 18px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 8px;
      cursor: pointer;
      transition: background-color 0.2s, color 0.2s, transform 0.1s, border-color 0.2s;
      outline: none;
      box-sizing: border-box;
    }

    #cart-conflict-modal .btn-confirm {
      background-color: #3d233d;
      color: #ffffff;
      border: none;
      box-shadow: 0 4px 12px rgba(61, 35, 61, 0.15);
    }

    #cart-conflict-modal .btn-confirm:hover {
      background-color: #522e52;
    }

    #cart-conflict-modal .btn-confirm:active {
      transform: scale(0.98);
    }

    #cart-conflict-modal .btn-cancel {
      background-color: transparent;
      color: var(--color-foreground, #2b2b2b);
      border: 1px solid var(--color-border, #cccccc);
    }

    #cart-conflict-modal .btn-cancel:hover {
      background-color: var(--color-background-secondary, #f5f5f5);
    }

    #cart-conflict-modal .btn-cancel:active {
      transform: scale(0.98);
    }

    /* Mobile Responsiveness */
    @media (max-width: 480px) {
      #cart-conflict-modal .modal-card {
        padding: 24px 20px;
        border-radius: 12px;
        width: 92%;
      }

      #cart-conflict-modal .modal-title {
        font-size: 19px;
        margin-bottom: 10px;
      }

      #cart-conflict-modal .modal-body {
        font-size: 13px;
        margin-bottom: 20px;
      }
    }
  `;
  document.head.appendChild(style);

  // Helper to parse if the add request contains a hamper item
  function isHamperAddition(url, options) {
    if (!options || !options.body) return false;
    
    try {
      if (typeof options.body === 'string') {
        const json = JSON.parse(options.body);
        if (json.items) {
          return json.items.some(item => {
            return item.properties && (
              item.properties['Hamper Type'] || 
              item.properties['Included in'] || 
              item.properties['_hamper_id']
            );
          });
        }
        return !!(json.properties && (
          json.properties['Hamper Type'] || 
          json.properties['Included in'] || 
          json.properties['_hamper_id']
        ));
      } else if (options.body instanceof FormData) {
        for (const [key, value] of options.body.entries()) {
          if (key.includes('properties[Hamper Type]') || 
              key.includes('properties[Included in]') || 
              key.includes('properties[_hamper_id]')) {
            return true;
          }
        }
      } else if (options.body instanceof URLSearchParams) {
        for (const [key, value] of options.body.entries()) {
          if (key.includes('properties[Hamper Type]') || 
              key.includes('properties[Included in]') || 
              key.includes('properties[_hamper_id]')) {
            return true;
          }
        }
      }
    } catch (e) {
      // If parsing fails, fall back to string scanning
      const bodyStr = String(options.body);
      if (bodyStr.includes('properties%5B_hamper_id%5D') || 
          bodyStr.includes('properties[_hamper_id]') || 
          bodyStr.includes('properties%5BHamper+Type%5D') || 
          bodyStr.includes('properties[Hamper Type]') ||
          bodyStr.includes('properties%5BIncluded+in%5D') ||
          bodyStr.includes('properties[Included in]')) {
        return true;
      }
    }
    return false;
  }

  // Fetch the current cart state
  async function getCartState() {
    try {
      const response = await originalFetch('/cart.js');
      if (!response.ok) return { hasHamper: false, hasNormal: false, itemsCount: 0 };
      const cart = await response.json();
      
      let hasHamper = false;
      let hasNormal = false;
      
      if (cart.items && cart.items.length > 0) {
        cart.items.forEach(item => {
          const props = item.properties;
          const isHamperItem = props && (
            props['Hamper Type'] || 
            props['Included in'] || 
            props['_hamper_id']
          );
          if (isHamperItem) {
            hasHamper = true;
          } else {
            hasNormal = true;
          }
        });
      }
      
      return { hasHamper, hasNormal, itemsCount: cart.item_count };
    } catch (e) {
      console.error('[Cart Validation] Error fetching cart state:', e);
      return { hasHamper: false, hasNormal: false, itemsCount: 0 };
    }
  }

  // Clear the cart
  async function clearCart() {
    try {
      const response = await originalFetch('/cart/clear.js', {
        method: 'POST'
      });
      return response;
    } catch (e) {
      console.error('[Cart Validation] Error clearing cart:', e);
    }
  }

  // Show the premium modal
  function showConflictModal({ title, message, confirmText, cancelText, onConfirm, onCancel }) {
    // Remove existing modal if any
    const existing = document.getElementById('cart-conflict-modal');
    if (existing) existing.remove();

    const modal = document.createElement('div');
    modal.id = 'cart-conflict-modal';

    const card = document.createElement('div');
    card.className = 'modal-card';

    const modalTitle = document.createElement('h3');
    modalTitle.className = 'modal-title';
    modalTitle.textContent = title;

    const modalBody = document.createElement('p');
    modalBody.className = 'modal-body';
    modalBody.textContent = message;

    const btnContainer = document.createElement('div');
    btnContainer.className = 'btn-container';

    const confirmBtn = document.createElement('button');
    confirmBtn.className = 'modal-btn btn-confirm';
    confirmBtn.textContent = confirmText;

    const cancelBtn = document.createElement('button');
    cancelBtn.className = 'modal-btn btn-cancel';
    cancelBtn.textContent = cancelText;

    confirmBtn.addEventListener('click', () => {
      closeModal();
      if (onConfirm) onConfirm();
    });

    cancelBtn.addEventListener('click', () => {
      closeModal();
      if (onCancel) onCancel();
    });

    btnContainer.appendChild(confirmBtn);
    btnContainer.appendChild(cancelBtn);
    card.appendChild(modalTitle);
    card.appendChild(modalBody);
    card.appendChild(btnContainer);
    modal.appendChild(card);
    document.body.appendChild(modal);

    requestAnimationFrame(() => {
      modal.style.opacity = '1';
      card.style.transform = 'scale(1)';
    });

    function closeModal() {
      modal.style.opacity = '0';
      card.style.transform = 'scale(0.92)';
      setTimeout(() => modal.remove(), 250);
    }
  }

  // Intercept fetch
  window.fetch = async function(resource, options) {
    const url = typeof resource === 'string' ? resource : (resource instanceof Request ? resource.url : '');
    
    // Check if adding to cart
    if (url.includes('/cart/add') || url.includes('/cart/add.js')) {
      const isAddingHamper = isHamperAddition(url, options);
      const cartState = await getCartState();

      if (cartState.itemsCount > 0) {
        // Conflict 1: Adding a normal product but cart contains a hamper
        if (!isAddingHamper && cartState.hasHamper) {
          return new Promise((resolve, reject) => {
            showConflictModal({
              title: 'Gift Box Restriction',
              message: 'Your cart contains a Custom Gift Box. Individual products cannot be added to a gift box order due to packaging and pricing constraints. Would you like to clear your cart and start fresh with this product?',
              confirmText: 'Clear Cart & Add Product',
              cancelText: 'Cancel',
              onConfirm: async () => {
                await clearCart();
                // Wait for cookies to sync to avoid Shopify cookie race conditions
                await new Promise(resolve => setTimeout(resolve, 500));
                const res = await originalFetch(resource, options);
                
                // If on cart page, reload is needed to sync sections
                if (window.location.pathname.includes('/cart')) {
                  window.location.reload();
                }
                resolve(res);
              },
              onCancel: () => {
                // Return a rejected-like response to let the caller handle completion cleanly
                resolve(new Response(JSON.stringify({
                  status: 422,
                  message: 'Cancelled',
                  description: 'Cancelled'
                }), {
                  status: 422,
                  headers: { 'Content-Type': 'application/json' }
                }));
              }
            });
          });
        }

        // Conflict 2: Adding a hamper but cart contains normal products
        if (isAddingHamper && cartState.hasNormal && !cartState.hasHamper) {
          return new Promise((resolve, reject) => {
            showConflictModal({
              title: 'Gift Box Restriction',
              message: 'Your cart contains individual products. Gift boxes cannot be clubbed with individual products due to packaging and pricing constraints. Would you like to clear your cart and start fresh with this Gift Box?',
              confirmText: 'Clear Cart & Add Gift Box',
              cancelText: 'Cancel',
              onConfirm: async () => {
                await clearCart();
                // Wait for cookies to sync to avoid Shopify cookie race conditions
                await new Promise(resolve => setTimeout(resolve, 500));
                const res = await originalFetch(resource, options);
                
                // If on cart page, reload is needed to sync sections
                if (window.location.pathname.includes('/cart')) {
                  window.location.reload();
                }
                resolve(res);
              },
              onCancel: () => {
                resolve(new Response(JSON.stringify({
                  status: 422,
                  message: 'Cancelled',
                  description: 'Cancelled'
                }), {
                  status: 422,
                  headers: { 'Content-Type': 'application/json' }
                }));
              }
            });
          });
        }
      }
    }

    return originalFetch(resource, options);
  };

  // Intercept checkout events/clicks
  document.addEventListener('click', async function(e) {
    const target = e.target;
    
    // Check if clicked element is a checkout link, button, or input
    const isCheckoutBtn = target.closest('[name="checkout"]') || 
                          target.closest('a[href*="/checkout"]') ||
                          (target.closest('form[action*="/cart"]') && target.closest('[type="submit"]'));
                          
    if (isCheckoutBtn) {
      const cartState = await getCartState();
      
      if (cartState.hasHamper && cartState.hasNormal) {
        e.preventDefault();
        e.stopPropagation();
        
        showConflictModal({
          title: 'Cart Conflict Detected',
          message: 'Your cart contains both a Custom Gift Box and individual products, which cannot be purchased together. Please adjust your cart to proceed to checkout.',
          confirmText: 'Go to Cart',
          cancelText: 'Close',
          onConfirm: () => {
            window.location.href = '/cart';
          },
          onCancel: () => {}
        });
      }
    }
  }, true);
})();
